export function storeCallbackRedirectUrl(): void {
  const { pathname, search } = new URL(window.location.href);
  const redirectUrl = `${pathname}${search}`;
  localStorage.setItem("target-url", redirectUrl);
}
